export default __webpack_public_path__ + "static/cli_labvendome-62c34bbd13c4ba3637b4e8ba80484428.png";